import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../store/app.state';
import { OfflineStorageService } from './offline-storage.service';
import { setLoadingSpinner } from '../store/actions/shared.action';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
    private router: Router,
    private store: Store<AppState>,
    private offlineStorageService: OfflineStorageService
  ) { }

  login(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/login', JSON.stringify(item), {withCredentials: true});
  }

  register(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/register', JSON.stringify(item), {withCredentials: true});
  }

  forgotPassword(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/forgot-password', JSON.stringify(item), {withCredentials: true});
  }

  resetPassword(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/auth/reset-password', JSON.stringify(item), {withCredentials: true});
  }

  logout(): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/user/logout', '', {withCredentials: true});
  }

  autoLogout(){
    this.logout().toPromise().then((res) => {
      this.router.navigateByUrl('/auth');
      this.offlineStorageService.clear();
      this.store.dispatch(setLoadingSpinner({status: false}));
    }).catch((err) => {
      console.log({err})
      this.store.dispatch(setLoadingSpinner({status: false}));
      this.offlineStorageService.clear();
      if(err?.status == 401){
        this.router.navigateByUrl('/auth');
      }
    })
  }
}
